module.exports = __webpack_public_path__ + "img/comp_evid.9e784fa4.png";